var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well-card-ghost"},[_c('div',{staticClass:"empty-well"},[_vm._v("\n        "+_vm._s(_vm.$translate('empty_well').toUpperCase())+"\n    ")])])}
var staticRenderFns = []
export { render, staticRenderFns }